export default __webpack_public_path__ + "static/media/10.ecdf4ee1.jpg";